import React from "react";
import { EmailTopicsPage } from "./EmailTopicsPage";

const EmailTopics = () => {
	return <EmailTopicsPage />;
};

export default EmailTopics;
